<template>
  <div class="big booking-activities">
    <div class="page_title">预约活动</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 10px 20px 20px 20px;">

        <div class="top-header">
          <div class="search-box">
            <!-- 活动名称 -->
            <div class="item">
              <span>活动名称</span>
              <div class="item-content">
                <el-input v-model="searchForm.act_name"
                          size="small"
                          clearable
                          @keyup.enter.native="seachEnterFun"
                          placeholder="请输入"></el-input>
              </div>
            </div>

            <!-- 活动状态 -->
            <div class="item">
              <span style="margin-left:10px">活动状态</span>
              <div class="item-content">
                <el-select v-model="searchForm.act_status"
                           size="small"
                           placeholder="请选择"
                           @change="seachEnterFun">
                  <el-option v-for="item in selectOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <el-button type="primary"
                         size="small"
                         style="margin-left:20px"
                         @click="getList">查询</el-button>
              <el-button size="small"
                         @click="restBtn">重置</el-button>
            </div>
          </div>
          <!-- 新增活动 -->
          <div style="margin-bottom: 10px;">
            <el-button type="primary"
                       size="medium"
                       :disabled="module_id_array[0]?!module_id_array.includes('1402'):false"
                       @click="addOrEditBtn(-1)">新增预约活动</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table v-loading="tableLoading"
                    :data="bookingActivitiesData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column v-for="item in tableHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :fixed="item.fixed">
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateTimeFormat }}
                </div>

                <div v-else-if="item.prop == 'activity_time'">
                  {{ scope.row['start_time'] | dateFormat }} -
                  {{ scope.row['end_time'] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'act_url'"
                     class="align-center"
                     @click="copyLink(scope.row[item.prop])">
                  <span> {{ scope.row[item.prop] }}</span>
                  <i class="el-icon-copy-document"
                     style="margin-left:6px;cursor: pointer;"></i>
                </div>

                <div v-else-if="item.prop == 'act_status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>
                <div v-else>
                  {{ !scope.row[item.prop] ? '' : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="220"
                             align="center"
                             fixed="right">

              <template slot-scope="scope">
                <el-button type="text"
                           size="medium"
                           @click="toDetail(scope.row.act_id)"
                           :disabled="module_id_array[0]?!module_id_array.includes('1400'):false">查看</el-button>
                <el-button type="text"
                           @click="edit(scope.row)"
                           v-if="scope.row.act_status !=2 && scope.row.act_status !=3"
                           :disabled="module_id_array[0]?!module_id_array.includes('1403'):false">编辑</el-button>
                <el-button type="text"
                           @click="toStatistics(scope.row)"
                           :disabled="module_id_array[0]?!module_id_array.includes('1404'):false">统计</el-button>
                <el-button v-if="scope.row.act_status !=2 && scope.row.act_status !=3"
                           type="text"
                           @click="delActivity(scope.row.act_id)"
                           :disabled="module_id_array[0]?!module_id_array.includes('1401'):false">作废</el-button>
              </template>

            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination v-show="totalNum>0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </div>
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import marketing from '@/api/marketing.js';
import Pagination from '@/components/Pagination/index';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      selectOptions: [
        {
          value: -1,
          label: '全部'
        },
        {
          value: 0,
          label: '未开始'
        },
        {
          value: 1,
          label: '进行中'
        },
        {
          value: 2,
          label: '已结束'
        },
        {
          value: 3,
          label: '已作废'
        }
      ],
      searchForm: {
        act_name: '',
        act_status: ''
      },
      tableHeader: [
        {
          label: '活动名称',
          prop: 'act_name',
          width: 'auto',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '创建时间',
          prop: 'create_time',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '活动备注',
          prop: 'act_remark',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '活动时间',
          prop: 'activity_time',
          width: '200',
          align: 'center',
          fixed: false
        },
        {
          label: '活动链接',
          prop: 'act_url',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '活动状态',
          prop: 'act_status',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      bookingActivitiesData: []
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD');
    },
    dateTimeFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    doctorAuthText(val) {
      switch (val) {
        case 1:
          return '全部医生';
        case 2:
          return '部分医生参与';
        case 3:
          return '部分医生不参与';
      }
    },
    statusText(val) {
      switch (val) {
        case 0:
          return '未开始';
        case 1:
          return '进行中';
        case 2:
          return '已结束';
        case 3:
          return '已作废';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(this.pagination, this.searchForm);
      this.tableLoading = true;
      marketing.getListPaging(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.bookingActivitiesData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    // 复制链接
    copyLink(link) {
      let oInput = document.createElement('input');
      oInput.value = link;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.remove();
      this.$message.success('复制成功');
    },
    // 查看
    toDetail(act_id) {
      this.$router.push({
        path: '/home/marketing/bookingActivities/addOrEditActivity',
        query: {
          act_id,
          type: 3
        }
      });
    },
    // 添加
    addOrEditBtn(act_id) {
      this.$router.push({
        path: '/home/marketing/bookingActivities/addOrEditActivity',
        query: {
          act_id,
          type: 1
        }
      });
    },
    //编辑活动
    edit(row) {
      this.$router.push({
        path: '/home/marketing/bookingActivities/addOrEditActivity',
        query: {
          act_id: row.act_id,
          type: row.act_status == 0 ? 4 : 2
        }
      });
    },
    //统计
    toStatistics(row) {
      let { act_id, act_name } = row;
      this.$router.push({
        path: '/home/marketing/bookingActivities/bookingActivityStatistics',
        query: {
          act_id,
          act_name
        }
      });
    },
    //作废
    delActivity(act_id) {
      this.$confirm('确认要作废当前活动吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          marketing.abandon({ act_id }).then((res) => {
            if (res.code == 0) {
              this.$message.success('作废成功');
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    restBtn() {
      for (let key in this.searchForm) {
        this.searchForm[key] = '';
      }
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.booking-activities {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>